/* eslint-disable import/prefer-default-export */

import { createAction } from "redux-actions";
import * as types from "./constants";

export const logInUser = createAction(types.LOG_IN_USER);
export const logOutUser = createAction(types.LOG_OUT_USER);
